import { render } from "./UserDetailsBasicInfo.vue?vue&type=template&id=0951c975&scoped=true"
import script from "./UserDetailsBasicInfo.vue?vue&type=script&lang=js"
export * from "./UserDetailsBasicInfo.vue?vue&type=script&lang=js"

import "./UserDetailsBasicInfo.vue?vue&type=style&index=0&id=0951c975&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0951c975"],['__file',"src/components/UserDetailsBasicInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0951c975"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0951c975', __exports__)) {
    api.reload('0951c975', __exports__)
  }
  
  module.hot.accept("./UserDetailsBasicInfo.vue?vue&type=template&id=0951c975&scoped=true", () => {
    api.rerender('0951c975', render)
  })

}


export default __exports__